/* eslint-disable @typescript-eslint/naming-convention */
import { createContext, useMemo, useState } from 'react';

import {
  BulkUserCreationContextProps,
  BulkUserCreationContextState,
} from './BulkUserCreationProvider.decl';

import { generateUniqId } from '@dashboard/library';

export const BulkUserCreationContext = createContext<BulkUserCreationContextState>(
  {} as BulkUserCreationContextState
);

export function BulkUserCreationProvider({ children }: BulkUserCreationContextProps) {
  const [funnelId, setFunnelId] = useState<string>(generateUniqId());

  const value = useMemo(
    () => ({
      state: {
        funnel_id: funnelId,
        is_part_of_onboarding: false,
      },
      actions: {
        initFunnelId: () => {
          const newFunnelId = generateUniqId();
          setFunnelId(newFunnelId);
          return newFunnelId;
        },
      },
    }),
    [funnelId]
  );

  return (
    <BulkUserCreationContext.Provider value={value}>{children}</BulkUserCreationContext.Provider>
  );
}
